export default __webpack_public_path__ + "static/banner-mobile-three-ec963f1056cbca6d3af938f527c6125b.jpg";